/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { useTable, usePagination } from "react-table";
import "./table.css";

/** @type {React.FC<{ columns: any, data: any, noDataMessage?: string }>} */
export const Paginated = ({ columns, data, noDataMessage = "" }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 20 }
    },
    usePagination
  );

  const { pageIndex, pageSize } = state;

  return (
    <>
         <table {...getTableProps()} className="custom-table">
        <thead >
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th  className="table-border"{...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.length === 0 && noDataMessage ? (
            <tr>
              <td colSpan={headerGroups[0]?.headers.length || 1} style={{ textAlign: "center" }}>
                {noDataMessage}
              </td>
            </tr>
          ) : page.map((row) => {
            prepareRow(row);

            return (
              <tr  {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {pageCount > 0 && (
        <div className="my-3 d-flex flex-column justify-content-center align-items-center ">
          <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ fontSize: "12px" }}>
            <button onClick={() => previousPage()} className="page_link_item" disabled={!canPreviousPage}>
              Previous
            </button>{" "}
            <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
              <span className="page_link_item">
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>{" "}
              </span>
              <span className="page_link_item">
                | Go to page:{" "}
                <input
                  type="number" className=""
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                  style={{ width: "50px" }}
                />
              </span>{" "}
            </div>
            <button onClick={() => nextPage()} className="page_link_item" disabled={!canNextPage}>
              Next
            </button>{" "}
            <select value={pageSize} className="page_link_item" onChange={(e) => setPageSize(Number(e.target.value))}>
              {[20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </div>

        </div>
      )}
    </>
  );
};
